import { j as x } from "../jsx-runtime-Drh4NO5G.mjs";
import * as r from "react";
import { getDataAttributes as w } from "./attribute-util.js";
const u = "GrapheneSVG", S = ({
  height: t = 32,
  width: e = 32,
  src: a,
  className: n,
  title: o,
  titleID: s,
  ariaHidden: h = !1,
  ...m
}) => {
  const [i, v] = r.useState(void 0), [l, g] = r.useState(void 0);
  r.useEffect(() => {
    let c = !0;
    return (async () => {
      const d = await b(a);
      c && (g(d.viewBox), v(d.path));
    })(), () => {
      c = !1;
    };
  }, [a, void 0]);
  const p = o ? `<title id="${s}">${o}</title> ${i}` : i, f = o ? { "aria-labelledby": s, role: "img" } : { role: "presentation", ...!o && h && { "aria-hidden": "true" } };
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      ...f,
      width: e,
      height: t,
      viewBox: l,
      className: n,
      "data-component": u,
      ...w(m),
      dangerouslySetInnerHTML: { __html: p }
    }
  );
};
S.displayName = u;
async function b(t) {
  try {
    const n = await (await (await fetch(t, { method: "GET", cache: "force-cache" })).blob()).text();
    return {
      viewBox: y(n),
      path: B(n)
    };
  } catch {
    return {
      viewBox: void 0,
      path: ""
    };
  }
}
function B(t) {
  return t.substring(1, t.length - 1).match(/<.*>/i).toString();
}
function y(t) {
  const e = t.match(/viewBox=['"]\d* \d* \d* \d*['"]/i);
  return e !== null ? e.toString().match(/\d* \d* \d* \d*/i).toString() : void 0;
}
export {
  S as GrapheneSVG
};
//# sourceMappingURL=GrapheneSVG.js.map
